import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const MonthlyCreationBarChart = ({ data = [] }) => (
  <ResponsiveContainer width="100%" height={220}>
    <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
      <CartesianGrid
        strokeDasharray="3 0"
        vertical={false}
        stroke="var(--dashboard-gray-200)"
      />
      <XAxis
        dataKey="name"
        tick={{ fontSize: 11, fill: "var(--dashboard-gray-500)" }}
        axisLine={false}
        tickLine={false}
      />
      <YAxis
        tick={{ fontSize: 11, fill: "var(--dashboard-gray-500)" }}
        axisLine={false}
        tickLine={false}
        allowDecimals={false}
      />
      <Tooltip />
      <Bar
        dataKey="value"
        name="Stores created"
        fill="var(--dashboard-blue)"
        radius={[4, 4, 0, 0]}
        barSize={22}
      />
    </BarChart>
  </ResponsiveContainer>
);

export default MonthlyCreationBarChart;
